import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";

import { RecoverabilityIndex } from "@/components/RecoverabilityIndex/recoverabilityIndex.types";
import * as ProductUtils from "@/utils/product.utils";

const GPC_RECOVERABILITY_INDEX_FEATURE_CODE_SUFFIX = ".0.622";

export const RecoverabilityIndexAdapter = (
    product: Product<ProductFieldSet.Full>
): RecoverabilityIndex | null => {
    const recoverabilityIndexFeature = ProductUtils.getFeatureValue(
        product,
        GPC_RECOVERABILITY_INDEX_FEATURE_CODE_SUFFIX
    );

    if (!recoverabilityIndexFeature?.imageURL) {
        return null;
    }

    return {
        imageUrl: recoverabilityIndexFeature.imageURL,
        altText:
            recoverabilityIndexFeature?.formattedValue || product.productTitle
    };
};
